import { useEffectWithController } from '@carvana/merch-react-hooks';
import { isSuccess } from '@carvana/merch-result';
import { useContext } from 'react';
import { httpWithAuth } from '~/clients';
import { TRADES } from '~/constants/endpoints';
import ErrorContext from '~/contexts/ErrorContext';
import FinanceAndTradeContext from '~/contexts/FinanceAndTradeContext';
import { useUserData } from '~/contexts/UserContext';
import TradesResponse, {
  TradeContent
} from '~/services/contracts/TradesResponse';
import generateErrorLogger from '~/utilities/errorHandlers';

function formatTradeInfo(tradeContent: TradeContent) {
  if (!tradeContent) return {};

  const {
    status,
    vehicleImages: { mobileImage },
    ...rest
  } = tradeContent;

  return {
    ...rest,
    mobileImage,
    status: status.charAt(0).toLowerCase() + status.slice(1),
    totalTradeInEquity: tradeContent.equity ?? null,
    totalTradeInValue: tradeContent.vehicleValue ?? null
  };
}

export default function useGetTrades() {
  const {
    tradeInfo: { setError, setLoaded, setLoading, setData }
  } = useContext(FinanceAndTradeContext);
  const { isLoggedIn } = useUserData();
  const { updateResponseErrors } = useContext(ErrorContext);

  useEffectWithController(
    controller => {
      if (!isLoggedIn) return;

      setLoading();

      httpWithAuth
        .get<TradesResponse>(TRADES, { signal: controller.signal })
        .then(({ data }) => {
          if (isSuccess(data)) {
            setData(formatTradeInfo(data.content[0]));
          }
        })
        .catch(
          generateErrorLogger('Trades', {}, { callback: setError, controller })
        )
        .finally(() => setLoaded());
    },
    [isLoggedIn, setData, setLoading, setLoaded, updateResponseErrors]
  );
}
